export const ADS_JOB_TYPES = [
  { id: 'legacy_csv', name: 'legacy_csv' },
  { id: 'gaql', name: 'gaql' }
];

export const ADS_JOB_SCHEDULES = [
  { id: 'hourly', name: 'hourly' },
  { id: 'daily', name: 'daily' },
  { id: 'once', name: 'once' }
];

export const ADS_JOB_ENABLED_CHOICES = [
  { id: 'true', name: 'Enabled' },
  { id: 'false', name: 'Disabled' }
];

export const ADS_JOB_WINDOW_MIN = 1;
export const ADS_JOB_WINDOW_MAX = 90;
export const ADS_JOB_LEGACY_WINDOW_WARN_ABOVE = 14;
export const ADS_JOB_RUN_AFTER_MAX = 23;
export const ADS_JOB_PRIORITY_MAX = 32767;

export const ADS_JOB_ENABLE_CONFIRM_TEXT = 'The job runs on the next hourly call of every account it applies to.';
export const ADS_JOB_ONCE_NOTE = "'once' makes the job due on the next call. After its ok run the job never runs again.";
export const ADS_JOB_LEGACY_WINDOW_WARNING = 'Keep 14 for the legacy reports until gate 1 — payload size.';
export const ADS_JOB_REPLACE_WINDOW_NOTE =
  "On: each run deletes this job's rows for the delivered dates (this account only), then writes what Google returned. Off: upsert — rows Google stops returning stay.";
